// JapanSolved™ OUTBOUND Inner Page v1.1 BAKED
// File: assets/outbound-v1.js

(() => {
  const root = document.querySelector('[data-jso-ob-root]');
  const mapEl = document.getElementById('JsoOutboundMap');
  if (!root || !mapEl) return;

  root.classList.add('js-ready');

  try {
    if (window.localStorage) {
      window.localStorage.setItem('japansolved_language_preference', 'ja');
      window.localStorage.setItem('japansolved_client_corridor', 'outbound');
    }
    document.documentElement.setAttribute('data-js-market-language', 'ja');
    document.documentElement.setAttribute('data-js-client-corridor', 'outbound');
    root.setAttribute('data-js-market-language', 'ja');
    root.setAttribute('data-js-client-corridor', 'outbound');
  } catch (error) {}

  let data;
  try {
    data = JSON.parse(mapEl.textContent);
  } catch (err) {
    console.warn('[OUTBOUND Inner v1] JSON map could not be parsed.', err);
    return;
  }

  const pages = Array.isArray(data.pages) ? data.pages : [];
  const handle = root.dataset.pageHandle || '';
  const current = pages.find(p => p.handle === handle) || pages[0];

  const heroImg = root.querySelector('[data-ob-hero]');
  const mobileSource = root.querySelector('[data-ob-source-mobile]');
  const titleEl = root.querySelector('[data-ob-title]');
  const leadEl = root.querySelector('[data-ob-lead]');
  const crumbTitle = root.querySelector('[data-ob-current-title]');
  const relatedWrap = root.querySelector('[data-ob-related]');
  const progress = root.querySelector('.jso-ob__progress');

  const THEME_KEYS = [
    'theme',
    'color-theme',
    'color_scheme',
    'color-scheme',
    'shopify-color-scheme',
    'preferred-theme',
    'prefers-color-scheme'
  ];

  const safeText = value => String(value || '').replace(/[<>&"]/g, char => ({
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;'
  }[char]));

  function textLooksLikeLightOrDark(text){
    if (!text) return null;
    const normalized = String(text).trim().toLowerCase();
    if (normalized === 'light' || normalized.includes(' light ') || normalized.includes('ライト') || normalized.includes('明るい')) return 'light';
    if (normalized === 'dark' || normalized.includes(' dark ') || normalized.includes('ダーク') || normalized.includes('暗い')) return 'dark';
    return null;
  }

  function attributeLooksLikeLightOrDark(value){
    if (!value) return null;
    const normalized = String(value).toLowerCase();
    if (normalized.includes('light') || normalized.includes('scheme-light') || normalized.includes('theme-light')) return 'light';
    if (normalized.includes('dark') || normalized.includes('scheme-dark') || normalized.includes('theme-dark')) return 'dark';
    return null;
  }

  function readStoredTheme(){
    try {
      for (const key of THEME_KEYS){
        const localValue = window.localStorage ? window.localStorage.getItem(key) : null;
        const sessionValue = window.sessionStorage ? window.sessionStorage.getItem(key) : null;
        const localTheme = attributeLooksLikeLightOrDark(localValue);
        if (localTheme) return localTheme;
        const sessionTheme = attributeLooksLikeLightOrDark(sessionValue);
        if (sessionTheme) return sessionTheme;
      }
    } catch (error) {}
    return null;
  }

  function readDomTheme(){
    const html = document.documentElement;
    const body = document.body;

    const tokens = [
      html.className,
      body ? body.className : '',
      html.getAttribute('data-theme'),
      body ? body.getAttribute('data-theme') : '',
      html.getAttribute('data-color-scheme'),
      body ? body.getAttribute('data-color-scheme') : '',
      html.getAttribute('color-scheme'),
      body ? body.getAttribute('color-scheme') : ''
    ];

    for (const token of tokens){
      const result = attributeLooksLikeLightOrDark(token);
      if (result) return result;
    }

    return null;
  }

  function readToggleTheme(){
    const selectors = [
      '[aria-label*="theme" i]',
      '[aria-label*="dark" i]',
      '[aria-label*="light" i]',
      '[data-theme-toggle]',
      '[data-color-scheme-toggle]',
      '.theme-toggle',
      '.color-scheme-toggle',
      'button'
    ];

    const candidates = Array.from(document.querySelectorAll(selectors.join(',')));

    for (const el of candidates){
      const combined = [
        el.getAttribute('aria-label'),
        el.getAttribute('title'),
        el.getAttribute('data-theme'),
        el.getAttribute('data-current-theme'),
        el.getAttribute('data-color-scheme'),
        el.textContent
      ].filter(Boolean).join(' ');

      const visibleState = textLooksLikeLightOrDark(combined) || attributeLooksLikeLightOrDark(combined);
      if (!visibleState) continue;

      // JapanSolved header pill tends to show the NEXT mode.
      return visibleState === 'dark' ? 'light' : 'dark';
    }

    return null;
  }

  function detectTheme(){
    return readDomTheme() || readStoredTheme() || readToggleTheme() ||
      (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');
  }

  function applyTheme(theme){
    const normalized = theme === 'light' ? 'light' : 'dark';
    root.setAttribute('data-jso-ob-current-theme', normalized);
    root.classList.toggle('jso-ob-theme-light', normalized === 'light');
    root.classList.toggle('jso-ob-theme-dark', normalized === 'dark');
  }

  function syncTheme(){
    applyTheme(detectTheme());
  }

  function delayedSync(){
    syncTheme();
    window.setTimeout(syncTheme, 60);
    window.setTimeout(syncTheme, 180);
    window.setTimeout(syncTheme, 420);
  }

  function assetUrl(file){
    if (!file) return '';
    if (/^https?:\/\//i.test(file) || file.startsWith('//')) return file;
    if (file.startsWith('/')) return file;
    return `/cdn/shop/files/${file}`;
  }

  function currentHeroSet(page){
    if (!page || !page.hero) return {};
    const mode = root.getAttribute('data-jso-ob-current-theme') === 'light' ? 'light' : 'dark';
    return {
      desktop: mode === 'light' ? page.hero.desktopLight : page.hero.desktopDark,
      mobile: mode === 'light' ? page.hero.mobileLight : page.hero.mobileDark
    };
  }

  function setHero(){
    if (!current || !current.hero) return;
    const set = currentHeroSet(current);

    if (heroImg && set.desktop){
      const next = assetUrl(set.desktop);
      if (heroImg.getAttribute('src') !== next){
        heroImg.style.opacity = '0';
        window.setTimeout(() => {
          heroImg.src = next;
          heroImg.style.opacity = '';
        }, 120);
      }
    }

    if (mobileSource && set.mobile){
      mobileSource.srcset = assetUrl(set.mobile);
    }
  }

  // Kanji slicing principle:
  // Prefer natural Japanese separators and visual phrase boundaries.
  function humanSlice(str, max){
    const input = String(str || '').trim();
    if (!input || input.length <= max) return input;

    const marks = ['｜', '／', '・', '、', '。', '：', ':', '　', ' '];
    let cut = max;

    for (const mark of marks){
      const idx = input.lastIndexOf(mark, max);
      if (idx > Math.floor(max * 0.55)){
        cut = idx;
        break;
      }
    }

    return input.slice(0, cut).replace(/[｜／・、。：:\s　]+$/g, '') + '…';
  }

  function setCopy(){
    if (!current) return;

    const fullTitle = current.title || document.title || '';
    const w = window.innerWidth || 1440;
    const maxTitle = w < 390 ? 18 : w < 520 ? 22 : w < 750 ? 30 : w < 990 ? 44 : 999;
    if (titleEl) titleEl.textContent = w < 990 ? humanSlice(fullTitle, maxTitle) : fullTitle;
    if (leadEl) leadEl.textContent = current.lead || current.short || data.fallback?.lead || leadEl.textContent;
    if (crumbTitle) crumbTitle.textContent = fullTitle;
  }

  function cardImage(page){
    const set = currentHeroSet(page);
    return assetUrl(set.desktop || set.mobile || '');
  }

  function renderRelated(){
    if (!relatedWrap) return;

    const related = pages.filter(p => p.handle !== handle);
    relatedWrap.innerHTML = related.map(page => `
      <a class="jso-ob__card" data-ob-card-handle="${safeText(page.handle)}" href="${safeText(page.url)}">
        <div class="jso-ob__thumb">
          <img src="${safeText(cardImage(page))}" alt="${safeText(page.title)}" loading="lazy">
        </div>
        <div class="jso-ob__card-body">
          <p class="jso-ob__card-kicker">${safeText(page.num)} ${safeText(page.kicker)}</p>
          <h3 class="jso-ob__card-title">${safeText(page.title)}</h3>
          <p class="jso-ob__card-short">${safeText(page.short)}</p>
        </div>
      </a>
    `).join('');
  }

  function revealSetup(){
    const items = root.querySelectorAll('.reveal-ob');

    if (!('IntersectionObserver' in window)){
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.10,
      rootMargin: '0px 0px -4% 0px'
    });

    items.forEach((el, i) => {
      el.style.transitionDelay = `${Math.min(i * 36, 260)}ms`;
      io.observe(el);
    });

    window.setTimeout(() => items.forEach(el => el.classList.add('is-visible')), 1800);
  }

  function onScroll(){
    if (!progress) return;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    progress.style.transform = `scaleX(${Math.min(1, Math.max(0, window.scrollY / max))})`;
  }

  let resizeTimer;

  function refresh(){
    syncTheme();
    setHero();
    setCopy();
    renderRelated();
    onScroll();
  }

  refresh();
  revealSetup();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refresh, 120);
  }, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('storage', delayedSync);
  window.addEventListener('pageshow', delayedSync);

  const observeThemeTarget = target => {
    if (!target) return;
    const observer = new MutationObserver(delayedSync);
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-theme', 'data-color-scheme', 'color-scheme']
    });
  };

  observeThemeTarget(document.documentElement);
  observeThemeTarget(document.body);

  document.addEventListener('click', event => {
    const target = event.target;
    if (!target || !target.closest) return;

    const clickedToggle = target.closest(
      '[data-theme-toggle], [data-color-scheme-toggle], .theme-toggle, .color-scheme-toggle, button, a'
    );

    if (!clickedToggle) return;

    const signature = [
      clickedToggle.getAttribute('aria-label'),
      clickedToggle.getAttribute('title'),
      clickedToggle.getAttribute('class'),
      clickedToggle.getAttribute('data-theme'),
      clickedToggle.getAttribute('data-color-scheme'),
      clickedToggle.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    if (
      signature.includes('theme') ||
      signature.includes('dark') ||
      signature.includes('light') ||
      signature.includes('ダーク') ||
      signature.includes('ライト')
    ) {
      delayedSync();
      window.setTimeout(refresh, 460);
    }
  }, true);

  if (window.matchMedia){
    const lightMQ = window.matchMedia('(prefers-color-scheme: light)');
    if (typeof lightMQ.addEventListener === 'function') {
      lightMQ.addEventListener('change', refresh);
    } else if (typeof lightMQ.addListener === 'function') {
      lightMQ.addListener(refresh);
    }
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('jso:theme-change', refresh);
})();



/* ==========================================================
   OUTBOUND INNER v1.1 REAL PATCH
   Authoritative theme repaint for hero + related thumbnails
   ========================================================== */
(() => {
  const root = document.querySelector('.jso-ob');
  const mapEl = document.getElementById('JsoOutboundMap');
  if (!root || !mapEl) return;

  let data;
  try { data = JSON.parse(mapEl.textContent); } catch(e) { return; }

  const pages = Array.isArray(data.pages) ? data.pages : [];
  const handle = root.dataset.pageHandle || '';
  const current = pages.find(p => p.handle === handle) || pages[0];

  function looksDarkToken(value){
    const v = String(value || '').toLowerCase();
    return v.includes('dark') || v.includes('ダーク') || v.includes('暗');
  }

  function looksLightToken(value){
    const v = String(value || '').toLowerCase();
    return v.includes('light') || v.includes('ライト') || v.includes('明');
  }

  function readTheme(){
    const html = document.documentElement;
    const body = document.body;

    const domTokens = [
      html.getAttribute('data-theme'),
      body && body.getAttribute('data-theme'),
      html.getAttribute('data-color-scheme'),
      body && body.getAttribute('data-color-scheme'),
      html.className,
      body && body.className
    ].join(' ');

    if (looksDarkToken(domTokens)) return 'dark';
    if (looksLightToken(domTokens)) return 'light';

    const toggle = document.querySelector('[aria-label*="DARK" i], [aria-label*="LIGHT" i], .theme-toggle, .color-scheme-toggle, [data-theme-toggle]');
    if (toggle){
      const label = [
        toggle.getAttribute('aria-label'),
        toggle.getAttribute('title'),
        toggle.textContent,
        toggle.getAttribute('data-theme'),
        toggle.getAttribute('data-current-theme')
      ].join(' ');

      // Header pill describes next available state in this theme.
      if (looksDarkToken(label)) return 'light';
      if (looksLightToken(label)) return 'dark';
    }

    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function assetUrl(file){
    if (!file) return '';
    if (/^https?:\/\//i.test(file) || file.startsWith('//')) return file;
    if (file.startsWith('/')) return file;
    return `/cdn/shop/files/${file}`;
  }

  function heroFor(page, mode){
    if (!page || !page.hero) return {};
    return {
      desktop: mode === 'dark' ? page.hero.desktopDark : page.hero.desktopLight,
      mobile: mode === 'dark' ? page.hero.mobileDark : page.hero.mobileLight
    };
  }

  function repaint(){
    const mode = readTheme();
    root.setAttribute('data-ob-theme', mode);

    if (current){
      const set = heroFor(current, mode);
      const hero = root.querySelector('[data-ob-hero]');
      const source = root.querySelector('[data-ob-source-mobile]');
      if (hero && set.desktop) hero.src = assetUrl(set.desktop);
      if (source && set.mobile) source.srcset = assetUrl(set.mobile);
    }

    const related = root.querySelector('[data-ob-related]');
    if (related){
      related.querySelectorAll('.jso-ob__card').forEach(card => {
        const cardHandle = card.getAttribute('data-ob-card-handle');
        const page = pages.find(p => p.handle === cardHandle);
        const img = card.querySelector('img');
        if (!page || !img) return;
        const set = heroFor(page, mode);
        img.src = assetUrl(set.desktop || set.mobile);
      });
    }

    // Mark html for CSS fallback
    document.documentElement.setAttribute('data-jso-ob-theme-last', mode);
  }

  function ensureCardHandles(){
    const related = root.querySelector('[data-ob-related]');
    if (!related) return;
    const cards = related.querySelectorAll('.jso-ob__card');
    const relatedPages = pages.filter(p => p.handle !== handle);
    cards.forEach((card, i) => {
      if (!card.getAttribute('data-ob-card-handle') && relatedPages[i]){
        card.setAttribute('data-ob-card-handle', relatedPages[i].handle);
      }
    });
  }

  const run = () => {
    ensureCardHandles();
    repaint();
    setTimeout(repaint, 80);
    setTimeout(repaint, 260);
    setTimeout(repaint, 700);
  };

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  window.addEventListener('pageshow', run);
  window.addEventListener('resize', () => setTimeout(repaint, 100), { passive: true });

  document.addEventListener('click', event => {
    const target = event.target && event.target.closest && event.target.closest('button, a, [role="button"], .theme-toggle, .color-scheme-toggle, [data-theme-toggle]');
    if (!target) return;
    const signature = [
      target.getAttribute('aria-label'),
      target.getAttribute('title'),
      target.className,
      target.textContent
    ].join(' ').toLowerCase();
    if (signature.includes('dark') || signature.includes('light') || signature.includes('theme') || signature.includes('ダーク') || signature.includes('ライト')){
      setTimeout(run, 60);
      setTimeout(run, 220);
      setTimeout(run, 520);
    }
  }, true);

  const mo = new MutationObserver(run);
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class','data-theme','data-color-scheme'] });
  if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class','data-theme','data-color-scheme'] });
})();


/* ==========================================================
   OUTBOUND INNER v1.2 FINAL POLISH
   Theme-class authority + reliable image repaint
   ========================================================== */
(() => {
  const root = document.querySelector('.jso-ob');
  const mapEl = document.getElementById('JsoOutboundMap');
  if (!root || !mapEl) return;

  let data;
  try { data = JSON.parse(mapEl.textContent); } catch(e) { return; }

  const pages = Array.isArray(data.pages) ? data.pages : [];
  const handle = root.dataset.pageHandle || '';
  const current = pages.find(p => p.handle === handle) || pages[0];

  function tokenDark(value){
    const v = String(value || '').toLowerCase();
    return v.includes('dark') || v.includes('ダーク') || v.includes('暗');
  }

  function tokenLight(value){
    const v = String(value || '').toLowerCase();
    return v.includes('light') || v.includes('ライト') || v.includes('明');
  }

  function detectTheme(){
    const html = document.documentElement;
    const body = document.body;

    const dom = [
      html.getAttribute('data-theme'),
      html.getAttribute('data-color-scheme'),
      html.getAttribute('color-scheme'),
      html.className,
      body && body.getAttribute('data-theme'),
      body && body.getAttribute('data-color-scheme'),
      body && body.className
    ].join(' ');

    if (tokenDark(dom)) return 'dark';
    if (tokenLight(dom)) return 'light';

    const candidates = Array.from(document.querySelectorAll('button, a, [role="button"], [aria-label], [data-theme-toggle], .theme-toggle, .color-scheme-toggle'));
    for (const el of candidates){
      const sig = [
        el.getAttribute('aria-label'),
        el.getAttribute('title'),
        el.getAttribute('data-theme'),
        el.getAttribute('data-current-theme'),
        el.textContent
      ].join(' ');

      /*
        Site header pill appears to show the NEXT available state:
        visible DARK = current light
        visible LIGHT = current dark
      */
      if (tokenDark(sig)) return 'light';
      if (tokenLight(sig)) return 'dark';
    }

    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function assetUrl(file){
    if (!file) return '';
    if (/^https?:\/\//i.test(file) || file.startsWith('//')) return file;
    if (file.startsWith('/')) return file;
    return `/cdn/shop/files/${file}`;
  }

  function pick(page, mode){
    if (!page || !page.hero) return {};
    return {
      desktop: mode === 'dark' ? page.hero.desktopDark : page.hero.desktopLight,
      mobile: mode === 'dark' ? page.hero.mobileDark : page.hero.mobileLight
    };
  }

  function markTheme(mode){
    root.classList.toggle('is-ob-dark', mode === 'dark');
    root.classList.toggle('is-ob-light', mode === 'light');
    root.setAttribute('data-ob-theme', mode);
  }

  function assignCardHandles(){
    const related = root.querySelector('[data-ob-related]');
    if (!related) return;
    const relatedPages = pages.filter(p => p.handle !== handle);
    related.querySelectorAll('.jso-ob__card').forEach((card, index) => {
      if (!card.getAttribute('data-ob-card-handle') && relatedPages[index]){
        card.setAttribute('data-ob-card-handle', relatedPages[index].handle);
      }
    });
  }

  function repaintImages(){
    const mode = detectTheme();
    markTheme(mode);

    if (current){
      const set = pick(current, mode);
      const hero = root.querySelector('[data-ob-hero]');
      const source = root.querySelector('[data-ob-source-mobile]');
      if (hero && set.desktop && hero.src !== assetUrl(set.desktop)) hero.src = assetUrl(set.desktop);
      if (source && set.mobile && source.srcset !== assetUrl(set.mobile)) source.srcset = assetUrl(set.mobile);
    }

    assignCardHandles();

    root.querySelectorAll('.jso-ob__card[data-ob-card-handle]').forEach(card => {
      const page = pages.find(p => p.handle === card.getAttribute('data-ob-card-handle'));
      const img = card.querySelector('img');
      if (!page || !img) return;

      const set = pick(page, mode);
      const next = assetUrl(set.desktop || set.mobile);
      if (next && img.src !== next) img.src = next;
    });
  }

  function noDesktopTruncation(){
    const title = root.querySelector('[data-ob-title]');
    if (!title || !current) return;
    if ((window.innerWidth || 1440) >= 990){
      title.textContent = current.title || title.textContent;
    }
  }

  function run(){
    repaintImages();
    noDesktopTruncation();
    setTimeout(() => { repaintImages(); noDesktopTruncation(); }, 80);
    setTimeout(() => { repaintImages(); noDesktopTruncation(); }, 260);
    setTimeout(() => { repaintImages(); noDesktopTruncation(); }, 700);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
  window.addEventListener('pageshow', run);
  window.addEventListener('resize', run, { passive: true });

  document.addEventListener('click', event => {
    const target = event.target && event.target.closest && event.target.closest('button, a, [role="button"], [aria-label], [data-theme-toggle], .theme-toggle, .color-scheme-toggle');
    if (!target) return;
    const sig = [target.getAttribute('aria-label'), target.getAttribute('title'), target.textContent, target.className].join(' ').toLowerCase();
    if (sig.includes('dark') || sig.includes('light') || sig.includes('theme') || sig.includes('ダーク') || sig.includes('ライト')){
      setTimeout(run, 60);
      setTimeout(run, 220);
      setTimeout(run, 520);
    }
  }, true);

  const mo = new MutationObserver(run);
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class','data-theme','data-color-scheme','color-scheme'] });
  if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class','data-theme','data-color-scheme','color-scheme'] });
})();
